import { put } from 'redux-saga/effects';
import { FabricationMockupsService } from '../../../services/FabricationMockups';
import { setNeedToRefreshProjects } from '../fabrication-projects/actions';
import {
  saveMockupFailure,
  saveMockupSuccess,
  loadMockupsFailure,
  loadMockupsSuccess,
  removeMockupFailure,
  removeMockupSuccess,
  setEditingMockup,
  loadMockups,
  editPavementFailure,
  editPavementSuccess
} from './actions';
import { IFabricationMockup, IPavement } from './types';
import { addToast } from '../toast/actions';
import { EToastTypes } from '../toast/types';

interface IMockupSagaParams {
  payload: {
    contractNumber: string;
    mockupId: number;
    mockupName: string;
    hasRoof: boolean;
    hasCovering: boolean;
    typicalFloorPlan: string;
    otherTypicalFloorPlan: string;
    pavements: IPavement[];
  };
}

interface IPavementsSagaParams {
  payload: {
    contractNumber: string;
    pavement: IPavement;
    mockupId: number;
  };
}

export function* saveFabricationMockupSaga(params: IMockupSagaParams) {
  const {
    contractNumber,
    mockupName,
    hasRoof,
    hasCovering,
    typicalFloorPlan,
    otherTypicalFloorPlan,
    pavements,
    mockupId
  } = params.payload;

  try {
    const mockupService = new FabricationMockupsService();
    if (mockupId) {
      yield mockupService.editFabricationMockup(
        mockupId,
        mockupName,
        hasRoof,
        hasCovering,
        typicalFloorPlan,
        otherTypicalFloorPlan,
        pavements
      );
      yield put(loadMockups(contractNumber));
      yield put(saveMockupSuccess());
      yield put(setNeedToRefreshProjects());
      yield put(
        addToast({
          message: 'Maquete editada com sucesso.',
          type: EToastTypes.SUCCESS,
          durationInMS: 5000,
          analyticsTag: {
            screenName: 'LG:MaquetesEProjetos:Maquetes:EditarMaquete',
            itemName: 'sucess:maquete_editada_com_sucesso',
            event: 'success',
            itemDescription:
              'maquetesEProjetos_maquetes_editarMaquete_maqueteEditadaComSucesso',
            nonInteraction: true
          }
        })
      );
    } else {
      const createdMockup: IFabricationMockup =
        yield mockupService.createFabricationMockup(
          contractNumber,
          mockupName,
          hasRoof,
          hasCovering,
          typicalFloorPlan,
          otherTypicalFloorPlan,
          pavements
        );
      yield put(setEditingMockup(createdMockup.id));
      yield put(saveMockupSuccess(createdMockup));
      yield put(
        addToast({
          message: 'Maquete criada com sucesso.',
          type: EToastTypes.SUCCESS,
          durationInMS: 5000,
          analyticsTag: {
            screenName: 'LG:MaquetesEProjetos:Maquetes:EditarMaquete',
            itemName: 'sucess:maquete_criada_com_sucesso',
            event: 'success',
            itemDescription:
              'maquetesEProjetos_maquetes_editarMaquete_maqueteCriadaComSucesso',
            nonInteraction: true
          }
        })
      );
    }
  } catch (err) {
    yield put(saveMockupFailure(err));
  }
}

export function* loadFabricationMockupSaga(params: IMockupSagaParams) {
  const { contractNumber } = params.payload;

  try {
    const mockupService = new FabricationMockupsService();
    const mockups: IFabricationMockup[] =
      yield mockupService.loadFabricationMockups(contractNumber);
    yield put(loadMockupsSuccess(mockups));
  } catch (err) {
    yield put(
      addToast({
        message: 'Falha ao carregar as maquetes.',
        type: EToastTypes.DANGER
      })
    );
    yield put(loadMockupsFailure(err));
  }
}

export function* removeFabricationMockupSaga(params: IMockupSagaParams) {
  const { mockupId, contractNumber } = params.payload;

  try {
    const mockupService = new FabricationMockupsService();
    yield mockupService.removeFabricationMockup(mockupId);
    yield put(removeMockupSuccess());
    yield put(loadMockups(contractNumber));
    yield put(
      addToast({
        message: 'Maquete removida com sucesso.',
        type: EToastTypes.SUCCESS,
        durationInMS: 5000
      })
    );
  } catch (err) {
    yield put(removeMockupFailure(err));
  }
}

export function* editPavementsSaga(params: IPavementsSagaParams) {
  const { contractNumber, pavement } = params.payload;

  try {
    const mockupService = new FabricationMockupsService();
    const {
      id,
      slabDate,
      beamDate,
      pillarDate,
      slabStatus,
      beamStatus,
      pillarStatus
    } = pavement;
    yield mockupService.editPavements(
      Number(id),
      slabDate,
      beamDate,
      pillarDate,
      slabStatus,
      beamStatus,
      pillarStatus
    );
    yield put(editPavementSuccess(Number(id)));
    yield put(
      addToast({
        message: 'Datas atualizadas com sucesso.',
        type: EToastTypes.SUCCESS,
        durationInMS: 5000
      })
    );
    yield put(loadMockups(contractNumber));
  } catch (err) {
    yield put(editPavementFailure(err));
  }
}
